import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon, FileTextIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-black py-4 md:py-6 px-4 overflow-hidden" data-id="element-88">
      <div className="max-w-3xl mx-auto text-center" data-id="element-89">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-[1.1] mb-3" data-id="element-90">
          Todo tu año de Psicología{' '}
          <span className="text-[#22c55e] italic" data-id="element-91">resuelto.</span>
        </h1>

        <div className="my-2 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300" onClick={scrollToPricing} data-id="element-92">
          <img src="https://cdn.magicpatterns.com/uploads/5rseM1fHuoj5CWwqKEKhsR/MOCKUPS_psicologia_.png" alt="Kit Completo Psicología Lista" className="w-full max-w-md mx-auto drop-shadow-2xl" data-id="element-93" />
        </div>

        <p className="text-[#22c55e] font-bold text-xl md:text-2xl italic mb-1" data-id="element-94">
          "Listo para usar. Sin buscar más."
        </p>

        <p className="text-gray-300 text-base md:text-lg mb-3 max-w-xl mx-auto" data-id="element-95">
          El sistema que usan docentes de Psicología de secundaria en Argentina
          para planificar{' '}
          <span className="font-bold text-white underline decoration-[#22c55e] underline-offset-4" data-id="element-96">
            todo el año en una tarde
          </span>
        </p>

        <div className="flex items-center justify-center gap-3 mb-2" data-id="element-97">
          <span className="flex items-center gap-1 text-gray-400 text-[11px] font-semibold whitespace-nowrap" data-id="element-98">
            <FileTextIcon className="w-2.5 h-2.5 text-[#22c55e]" data-id="element-99" /> 100% PDF
          </span>
          <span className="text-gray-600 text-[10px]" data-id="element-100">•</span>
          <span className="flex items-center gap-1 text-gray-400 text-[11px] font-semibold whitespace-nowrap" data-id="element-101">
            <ZapIcon className="w-2.5 h-2.5 text-[#22c55e]" data-id="element-102" /> Acceso inmediato
          </span>
          <span className="text-gray-600 text-[10px]" data-id="element-103">•</span>
          <span className="flex items-center gap-1 text-gray-400 text-[11px] font-semibold whitespace-nowrap" data-id="element-104">
            🇦🇷 Currículo argentino
          </span>
        </div>

        <div className="flex justify-center mb-1" data-id="element-105">
          <CTAButton onClick={scrollToPricing} className="text-sm px-5 py-2.5 whitespace-nowrap" data-id="element-106">
            → QUIERO MI KIT COMPLETO AHORA
          </CTAButton>
        </div>

        <div className="flex items-center justify-center gap-2 text-[9px] md:text-[10px] text-gray-500 font-medium" data-id="element-107">
          <span className="flex items-center gap-0.5 whitespace-nowrap" data-id="element-108">
            <ShieldCheckIcon className="w-2.5 h-2.5 text-green-600" data-id="element-109" /> Garantía
            7 días
          </span>
          <span className="text-gray-600" data-id="element-110">•</span>
          <span className="flex items-center gap-0.5 whitespace-nowrap" data-id="element-111">
            <LockIcon className="w-2.5 h-2.5 text-green-600" data-id="element-112" /> Pago 100% seguro
          </span>
          <span className="text-gray-600" data-id="element-113">•</span>
          <span className="flex items-center gap-0.5 whitespace-nowrap" data-id="element-114">
            <CreditCardIcon className="w-2.5 h-2.5 text-green-600" data-id="element-115" /> Mercado
            Pago
          </span>
        </div>
      </div>
    </section>;
}